export const environment = process.env.REACT_APP_ENV;

export const variablesGlobales = {

    urlServiceBackend: process.env.REACT_APP_ENDPOINT_API_GAILIEA, // ? "" : environment === 'LOCAL' ? "http://localhost:4009" : "https://backend-lb.galilea.co",
    //urlWompiCheckoutBackend: environment === 'DEV' ? "https://wompi-checkout.galilea.co/checkout/sandbox" : environment === 'LOCAL' ? "https://wompi-checkout.galilea.co/checkout/sandbox" : "https://wompi-checkout.galilea.co/checkout",
    urlServiceWebsocket: process.env.REACT_APP_ENDPOINT_API_WS, // ? "wss://dev.galilea.co/ws/" : environment === 'LOCAL' ? "http://localhost:4009" : "https://backend-lb.galilea.co/ws/",
    urlServiceDateTime: process.env.REACT_APP_ENDPOINT_API_DATETIME, //"https://galilea-datetime-service-448541521578.us-east1.run.app/api/v1/",
    //passBackoffice: "WantonioG@2022",
    // test: "test",
    // timemaxSignupForm: 5,
    typeUserVisitor: process.env.REACT_APP_TYPE_USER_VISITOR, // "visitor",
    typeUSerClient: process.env.REACT_APP_TYPE_USER_CLIENT, //"client",
    //urlServiceImports: environment === 'DEV' ? "https://dev.galilea.co/backend/sandbox/" : environment === 'LOCAL' ? "http://localhost:4009" : "https://backend-lb.galilea.co/backend/imports",
    urlRedirectCobre: process.env.REACT_APP_URL_REDIRECT_COBRE, // ? "https://galilea.co/micredito" : environment === 'LOCAL' ? "http://localhost:3000/micredito" : "https://dev.galilea.co/micredito",
    vapidKey: process.env.REACT_APP_VAPID_KEY, // "BLstrXXUsakuvA9uqw4O9Dp2LAW72DjHWKRrz49VYAM4FK2tI3Hi9M4b72RKoGbe37O5ehUU88CTaDv041yt4m4",
    firmaElectronica: process.env.REACT_APP_FIRMA_ELECTRONICA, //145000,
    dctoFirmaElectronica: process.env.REACT_APP_DCTO_FIRMA_ELECTRONICA, //72500,
    endpointApiChatAi: process.env.REACT_APP_ENDPOINT_CHAT_IA,
    usernameApiChatIa: process.env.REACT_APP_USERNAME_API_CHAT_IA || "",
    passwordApiChatIa: process.env.REACT_APP_PASSWORD_API_CHAT_IA || "",
    pub_key_wompi: process.env.REACT_APP_PUB_KEY_WOMPI,
    //urlWompiCheckouGcp: process.env.REACT_APP_URL_WOMPI_CHECKOUT_GCP,
    policyData: process.env.REACT_APP_POLICY_DATA,
    x_api_key_wompi_checkout: process.env.REACT_APP_X_API_KEY_WOMPI_CHECKOUT,
    url_whk_n8n: process.env.REACT_APP_URL_WHK_N8N,
    api_key_whk_n8n: process.env.REACT_APP_APIKEY_WHK_N8N,
    partnerIdGoogleAds: process.env.REACT_APP_GOOGLE_ADS_PARTNER_ID || "",
    partnerUtmNameGoogleAds: process.env.REACT_APP_PARTNER_UTM_NAME_GOOGLE_ADS || "google_ads",
    partnerUtmNameTiktokAds: process.env.REACT_APP_PARTNER_UTM_NAME_TIKTOK_ADS || "tiktok_ads",
    partnerUtmNameMetaAds: process.env.REACT_APP_PARTNER_UTM_NAME_META_ADS || "facebook_organic",
    eventNameLoanSigned: process.env.REACT_APP_EVENT_NAME_LOAN_SIGNED, //"LoanSigned",
    eventNameLoanSignedTiktok: process.env.REACT_APP_EVENT_NAME_LOAN_SIGNED_TIKTOK, //"ApplicationApproval",
    glitchtipDsn: process.env.REACT_APP_GLITCHTIP_DSN,
    umamiScriptUrl: process.env.REACT_APP_UMAMI_SCRIPT_URL || "https://beacon.galilea.co/script.js",
    umamiWebsiteId: process.env.REACT_APP_UMAMI_WEBSITE_ID || "",
    umamiDomains: process.env.REACT_APP_UMAMI_DOMAINS || "",
}
